import * as INR from "./INR.ts";
import * as Html from "./util/Html.ts";
import ApiServer from "./ApiServer.js";
import * as forms from "./util/forms.js";
import * as modal from "./util/modal.ts";
import * as i18n from "./i18n.ts";
import * as actionsUnlogged from "./actions_unlogged.js";
import * as libLocation from "./lib/location.ts";
import * as ga from "./tracking-googleanalytics.js";
import * as login from "./features/login.js";
import FizConfig from "./FizConfig.js";
import * as OS from "./lib/os.js";
import deviceId from "./lib/deviceId.js";
import * as Storage from "./lib/Storage.ts";

const PROMOCODE = JSON.parse(Storage.sessionGet('PROMOCODE')||"{\"ask\":false}");
var 
  fw2Context = {}, 
  invitationReceived, 
  originalTitle = document.title,
  //define startSequence for page needing invitation
  startSequence = actionsUnlogged.getStartSequence(false,function(callback,data){

    var 
      iid = libLocation.getURLParam("iid"),
      v =  libLocation.getURLParam("v");
    if(invitationReceived===undefined && iid){
      //TODO find where it mights happens
      if(libLocation.getURLParam("logged")==="true"){
        ApiServer.famacceptinvitation(iid, v,function(invit) {
          libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
        });
        return;
      }
      ApiServer.famgetinvitation(iid, v, function(invit) {
        invitationReceived = invit;
        PROMOCODE.isInvit = true;
        invitationReceived.identifier=libLocation.getURLParam("identifier");
        
        ApiServer["custom.signuponinvite"] = async function(form){
          invitationReceived.identifier=form.a00identifier.value;
          try{
            await ApiServer.log2in(form);
            ApiServer.famacceptinvitation.prepare(iid, v, "TOKEN",invitationSuccess, invitationError)
          }catch(e){
            ApiServer.group([ 
              ApiServer.log2create,
              ApiServer.accsetprofile,
              ApiServer.accgetstate.prepare(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone()),
              ApiServer.accsetterms.prepare(true),
              ApiServer.famacceptinvitation.prepare(iid, v, "TOKEN"),
              ApiServer.accsendwelcomeemail
              ],invitationSuccess, invitationError)(form);
          }
          
        };
        ga.event("Join_fromEmail|Join_Email|$DEVICE_Join");
        let 
          daysSinceInvite = (new Date()-invit.invitation.creationDate)/(24*60*60*1000),
          roundedDaysSinceInvite = Math.floor(daysSinceInvite*10)/10;
          
        if(invit.invitation.token.sms){
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_SMS_Invitation|"+roundedDaysSinceInvite)
        }else if(invit.invitation.token.email){
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_Email_Invitation|"+roundedDaysSinceInvite)
        }else{
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_Whatsapp_Invitation|"+roundedDaysSinceInvite)
        }
        
        
        callback(invitationReceived);
      }, invitationError);
    }else{
      callback(invitationReceived||fw2Context);
    }
  }),
  startSequenceWithFamilies = actionsUnlogged.getStartSequence(false,function(callback,data){
    ApiServer.famlistfamily(function(famList) {
      data.families = famList; 
      data.signup = PROMOCODE.signup;
      if(famList.length>1){
        data.multifamily = true;
      }
      callback(data);
    });
  }),
  startSequenceDeepLink = actionsUnlogged.getStartSequence(false,function(callback,data){
    data = invitationReceived||data;
    function onError(){
      data.deepLoginLink = FizConfig.noWeb?null:INR.URL.ENTER_HOME;
      callback(data);
    }
    ApiServer.accgetloggedaccount(function(acc){
      acc.identifiers.forEach(function(accIdentifier){
        if(accIdentifier.type==='Login') data.identifier = accIdentifier.value;
        if(accIdentifier.type==='Email') data.identifier = accIdentifier.value;
      });
      ApiServer.accgenerateDeepLoginLink(INR.URL.ENTER_HOME,FizConfig.noWeb,function(link){
        data.deepLoginLink = link;
        data.signup = PROMOCODE.signup;
        callback(data);
      },onError);
    },onError);
  });

  
  
  
ApiServer.types.InvitationReceivedBean.prototype.urlParams = function(){
  return "?iid="+encodeURIComponent(this.iid)+"&v="+encodeURIComponent(this.v)+(this.identifier?"&identifier="+encodeURIComponent(this.identifier):"");
};
  
INR.createPage(
  INR.URL.FW2_INVITATION,
  startSequence,
  function(){
    return Promise.all([import('./nc/invitation.mustache')])
  },
  "fw2"
);
INR.createPage(INR.URL.FW2_SIGNUP,
    startSequence,
    function(){
      return Promise.all([import('./nc/signup.mustache')])
    }, 
    "fw2"
  );
INR.createPage(INR.URL.FW2_SIGNUP_FAMILY,
    startSequence,
    function(){
      return Promise.all([import('./nc/signup_family.mustache')])
    }, 
    "fw2"
  );
INR.createPage(INR.URL.FW2_SIGNUP_ALL,
    startSequence,
    function(){
      return Promise.all([import('./nc/signup_all.mustache')])
    }, 
    "fw2"
  );
INR.createPage(
  INR.URL.FW2_SIGNIN,
  startSequence,
  function(){
    return Promise.all([import('./nc/signin.mustache')])
  },
  "fw2"
);

INR.createPage(
  INR.URL.FW2_INVITATION_PROFILE,
  startSequence,
  function(){
    return Promise.all([import('./nc/invitationprofile.mustache')])
  },
  "fw2"
);

INR.createPage(INR.URL.FW2_INVITATION_SUCCESS,
    startSequenceDeepLink,
    function(){
      return Promise.all([import('./nc/invitation_success.mustache')])
    },
    "fw2"
  );

INR.createPage(INR.URL.FW2_INVITATION_ERROR,
    startSequence,
    function(){
      return Promise.all([import('./nc/invitation_error.mustache')])
    },
    "fw2"
  );

INR.createPage(INR.URL.FW2_BLOCKINVITATION,
    startSequence,
    function(){
      return Promise.all([import('./nc/blockinvitation.mustache')])
    },
    "fw2"
  );
INR.createPage(INR.URL.FW2_BLOCKINVITATION_SUCCESS,
    startSequence,
    function(){
      return Promise.all([import('./nc/blockinvitation_success.mustache')])
    },
    "fw2"
  );

function invitationSuccess() {
  document.title = originalTitle;
  if (invitationReceived) {
    ga.invitationevent("Invite_Member|D_Invitation_Accepted|Account_Created|1")
    ga.event("Join|Join_Completed|Join_completed");
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  }else{
    libLocation.goTo(INR.URL.ACTIVITY);
  }
}
function signupSuccess() {
  ga.event({
    'event': 'signUpCompleted',
    'form_name': 'signup form'
  })  

  let 
    recipeToSave = getRecipeToSave();
  
  
  if(recipeToSave){
    ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
      Storage.sessionRemove('recipeToSave')
    })
  }
  if(login.handleAfterLogin()){
    return;
  }
  if(PROMOCODE.ask /* || (!OS.hasApp && FizConfig.CONFIG_PARTNER_TYPE==='Family') */){ //asked by nf 20230103 users where asking support for a promocode
    PROMOCODE.signup = true;
    libLocation.goTo(INR.URL.FW2_PROMOCODE);
  }else if(OS.hasApp||FizConfig.noWeb){
    PROMOCODE.signup = true;
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  }else if(PROMOCODE.isInvit){
    libLocation.goTo(INR.URL.ENTER_HOME);
  }else{  
    libLocation.goTo(INR.URL.ENTER_HOME+"?modal=welcome");
  }
}  
function loginError(ex) {
  console.log(ex)
  if(ex.message === ""){
    modal.alert("fw2.apierrors.notconnected"); 
  }else if(ex.message === "timeout"){
    modal.alert("fw2.defaultError"); 
  }else if (ex.code === '12') {
    invitationSuccess()
  } else {
    modal.alert("errors.loginFailed");
  }
}
function invitationError(ex) {
  console.log(ex)
  // account already exists
  if (ex.code === '2') {
    modal.alert("fw2.apierrors.2", function() {
      libLocation.goTo(INR.URL.FW2_SIGNIN);
    });
  }else if (ex.code === '16' && ex.tokenType==='InvitationAccepted') {
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  } else {
    ga.event("Invitation|Error|"+ex.message+"|"+ex.code);
    libLocation.goTo(INR.URL.FW2_INVITATION_ERROR);
  }
}
INR.onPage(INR.URL.FW2_INVITATION_SUCCESS, function() {
  libLocation.enable();
});
INR.onPage(INR.URL.FW2_INVITATION, function() {
  libLocation.disable();
  if (invitationReceived && invitationReceived.invitation.token.accountIdentifierId) {
    libLocation.goTo(INR.URL.FW2_SIGNIN);
    return;
  }
  document.title = i18n.get("fw2.invitation.title");
  ApiServer["custom.invitationsetemail"] =  function(form){
    invitationReceived.firstname = form.firstname.value || invitationReceived.firstname;
    var identifier = form.a00identifier.value;
    ApiServer.log2check('Email',identifier,
      function(isFree){
        invitationReceived.identifier=identifier;
        ga.event("Join|Continue_Process|Continue_Process");
        if(isFree){
          libLocation.goTo(INR.URL.FW2_INVITATION_PROFILE+invitationReceived.urlParams());   
        }else{
          invitationReceived.alreadymember = true;
          libLocation.goTo(INR.URL.FW2_SIGNIN);  
        }
      },function(err){
        forms.markInvalid($('input[name=a00identifier]'),i18n.get("invitationJs.errorEmail"));
      }
    );
  }  
});
INR.onPage(INR.URL.FW2_INVITATION_PROFILE, function() {
  ApiServer["custom.signuponinvitefake"] = invitationSuccess;
  
});

ApiServer["custom.signin"] = ApiServer.group([
    ApiServer.log2in,
    fw2Context.ApiPromo||ApiServer.log2get
  ],async function(accountLoginInfo){
  
  let 
    recipeToSave = getRecipeToSave();
  
  if(login.handleAfterLogin()){
    return;
  }else if(!accountLoginInfo.termsChecked){
    libLocation.goTo(INR.URL.FW2_TERMS);
  
  }else if(PROMOCODE.ask){
    libLocation.goTo(INR.URL.FW2_PROMOCODE);
  
  }else if(FizConfig.noWeb){
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS)
  
  }else if(recipeToSave){
    ApiServer.famlistfamily(function(families){
      if(families.length===1){
        
        ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
          Storage.sessionRemove('recipeToSave')
          libLocation.goTo("recipebox.php?id="+savedRecipe.metaId);
        })    
      }else{
        libLocation.goTo("familypick.php");
      }
    })
  }else{
    //use window location to activate "Do you want to register login/password" popup from browser
    if(ApiServer.usejessionidinurl){
      libLocation.goTo(INR.URL.ENTER_HOME+"?result=200");
    }else{
      window.location=(INR.URL.ENTER_HOME+"?result=200");
    }
  }
  
  },loginError);

INR.onPage(INR.URL.FW2_SIGNIN, function() {
  var apis = [ ApiServer.log2in ];
  if (invitationReceived) {
    apis.push(ApiServer.famacceptinvitation.prepare(invitationReceived.iid, invitationReceived.v));
  }
  ApiServer["custom.signinoninvite"] = ApiServer.group(apis, function(){
    if (invitationReceived) {
      invitationReceived.identifier=$("input[name='a00identifier']").val() || invitationReceived.identifier;
    }
    invitationSuccess();
  }, loginError).setOptions({timeout:120000,defaultErrorHandler:function(e){throw e}});

});
INR.onPage(INR.URL.FW2_BLOCKINVITATION, function() {
  ApiServer["custom.blockinvitation"] = ApiServer.famblockinvite.prepare(invitationReceived.iid,invitationReceived.v, true,function(){
    libLocation.goTo(INR.URL.FW2_BLOCKINVITATION_SUCCESS);
  });

});
ApiServer["custom.signup1"] = ApiServer.group([
  ApiServer.log2create,
  ApiServer.accsetprofile,
  ApiServer.accgetstate.prepare(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone())              
],function(){
  invitationReceived = {invitation:{firstname:this.data.a01firstname},identifier:this.data.a00identifier};
  ApiServer.accsendaccountidentifiervalidationcode(null,null,this.data.a00identifier,null,"TOKEN"),
  libLocation.goTo(INR.URL.FW2_SIGNUP_FAMILY);
},function(ex){
  console.log(ex)
  modal.alert("fw2.defaultError");
});
ApiServer["custom.signup2"] = ApiServer.group([
    ApiServer.acccreatefamily.prepare({cover:"/mediadefault/familyCover"}),
    ApiServer.accsetterms.prepare(true),
    fw2Context.ApiPromo?fw2Context.ApiPromo:ApiServer.log2get
    
  ],function(){
    ApiServer.accsendwelcomeemail();
    signupSuccess();
  },function(ex){
    console.log(ex)
    modal.alert("fw2.defaultError");
});

ApiServer["custom.signupall"] = ApiServer.group([
  ApiServer.log2create,
  ApiServer.accsetprofile,
  ApiServer.accgetstate.prepare(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone()),
  ApiServer.acccreatefamily,
  ApiServer.accsetterms.prepare(true),
  fw2Context.ApiPromo?fw2Context.ApiPromo:ApiServer.log2get
],function(){
  invitationReceived = {invitation:{firstname:this.data.a01firstname},identifier:this.data.a00identifier}
  ApiServer.accsendwelcomeemail();
  ApiServer.accsendaccountidentifiervalidationcode(null,null,this.data.a00identifier,null,"TOKEN"),
  signupSuccess();
},function(ex){
  console.log(ex)
  modal.alert("fw2.defaultError");
});

INR.createPage(INR.URL.FW2_PROMOCODE_VOUCHER,
  startSequence,
  function(){
    return Promise.all([import('./nc/promocode_voucher.mustache')])
  },
  "fw2"
);
INR.onPage(INR.URL.FW2_PROMOCODE_VOUCHER,function(){
  PROMOCODE.ask = true;
  PROMOCODE.code = libLocation.getURLParam('promo');
  Storage.sessionSet('PROMOCODE',JSON.stringify(PROMOCODE));
});

INR.createPage(INR.URL.FW2_PROMOCODE,
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/promocode.mustache')])
  },
  "fw2"
);
INR.onPage(INR.URL.FW2_PROMOCODE,function(){
  if(PROMOCODE.code){
    Storage.sessionRemove('PROMOCODE');
    $('.nc-layout').hide();
    $("input[name='a01value']").val(PROMOCODE.code);
    $("form").trigger('submit');
  }
});

INR.createPage(INR.URL.FW2_TERMS,
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/terms.mustache')])
  },
  "fw2"
);


ApiServer["custom.promocode"] = ApiServer.group([ApiServer.famlogfamily,ApiServer.creditusepromocode],function(){
  if(PROMOCODE.signup){
    if(OS.hasApp||FizConfig.noWeb){
      libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
    }else{ 
      libLocation.goTo(INR.URL.ENTER_HOME+"?modal=welcome");
    }
  }else{
    libLocation.goTo(INR.URL.ENTER_HOME+"?modal=promocode");
  }  
  
},function(ex){
  $('.nc-layout').show();
  if(ex.code==='403'){
    modal.alert("fw4.promocode.error");
  }else{
    modal.alert("fw2.defaultError");
  }
  
});

INR.createPage(
  "familypick.php",
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/pickfamily.mustache')])
  },
  "fw2",
);
    
INR.createPage(
  INR.URL.EMAIL_VALIDATE,
  startSequenceDeepLink,
  function(){
    return Promise.all([import('./nc/email_validate.mustache')])
  },
  "fw2",
);

Html.register({
  saverecipefamily:function(metaId){
    ApiServer.famlogfamily(metaId);
    let 
      recipeToSave = getRecipeToSave();
    
    ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
      Storage.sessionRemove('recipeToSave');
      libLocation.goTo("recipebox.php?id="+savedRecipe.metaId);
    })
  }
})
    
function getRecipeToSave(){
  let 
    recipeToSaveString = Storage.sessionGet('recipeToSave');
  
  if(recipeToSaveString) {
    let 
      recipeToSaveJson = JSON.parse(recipeToSaveString),
      result = new ApiServer.types.RecipeInputBean(recipeToSaveJson);
    
    result.metaId = null;
    result.pictures = recipeToSaveJson.medias.map(media=>media.pictureUrl);
    return result;
  }else{
    return null;
  }

  
}

INR.createPage(
  "token.php",
  startSequence,
  function(){
    return Promise.all([import('./nc/invitation.mustache')])
  },
  "fw2"
);
INR.onPage("token.php",function(){
  ApiServer.log2token(libLocation.getURLParam('v'),function(tokenResponse){
    libLocation.goTo(tokenResponse.redirectUrl,true);
  },function(){
    libLocation.goTo('error_token.php',true);
  })
});
